module.exports = __webpack_public_path__ + "img/75753.206627e4.svg";